
import Product from '../components/Product';


function Shop() {
  
  return (
    <>
   <div className="shop-hero">
    <div className=" shop-content container">
        <h2>Product Catalog</h2>
    </div>
  </div>
  <Product/>
  
    </>
  )
}

export default Shop;